<template>
  <div id="catalog">
     <!-- Catalog -->
      <div v-if="ai===1" :class="{'disabled': showFavs }" class="input-group md-form form-sm form-2 pl-0 mb-2 mt-2">
        <template v-if="goods.length > 0">
         <div class="input-group-prepend">
             <button v-if="!spinner" @click = "changeView(true)" class="btn btn-nav text-white blue-grey darken-4 hoverable animated fadeIn" title="Переключить режим вывода товаров на построчный"><i class="fa-solid fa-list"></i></button>
             <button v-if="!spinner" @click = "changeView(false)" class="btn btn-nav text-white blue-grey darken-4 hoverable animated fadeIn" title="Переключить режим вывода товаров на табличный"><i class="fa-solid fa-table"></i></button>
             <button v-if="!spinner && sort === 0" @click = "changeSort()" class="btn btn-nav text-white blue-grey darken-4 hoverable animated fadeIn" title="Сортировка цен по возрастанию"><i class="fa-solid fa-arrow-up-1-9"></i></button>
             <button v-if="!spinner && sort === 1" @click = "changeSort()" class="btn btn-nav text-white blue-grey darken-4 hoverable animated fadeIn" title="Сортировка цен по убыванию"><i class="fa-solid fa-arrow-down-9-1"></i></button>
             <button v-if="!spinner && sort === 2" @click = "changeSort()" class="btn btn-nav text-white blue-grey darken-4 hoverable animated fadeIn" title="Сортировка по алфавиту"><i class="fa-solid fa-arrow-down-a-z"></i></button>
             <span v-if="!spinner" class="input-group-text text-white cyan darken-4 animated fadeIn" title=""><i class="fa fa-search" aria-hidden="true" ></i></span>
             <div v-if="spinner" class="input-group-text text-white cyan darken-4" style="z-index:100000;"><Circle8></Circle8></div>
        </div>
        <input @input="debounceSearch" ref="inp" class="form-control" v-bind:class="{'red-text':filteredList.length === 0 && goods.length > 0, 'text-info':filteredList.length > 100 &&  filteredList.length < goods.length}"  type="text" placeholder="Поиск" aria-label="Search" title="Введите ключевые слова в поле поиска">
        <span class="input-group-text text-white blue-grey darken-4 hoverable" title="Очистить поле ввода" @click="debounceClean()" id="basic-text1"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
      </template>
      </div>
      <template v-if="isMobile && filteredList.length > 400">
     <div class="card">
     <card-header>
       Тэги
        <button v-if="!closetags" @click="closetags = true" type="button" title = "Скрыть тэги" class="close animated zoomIn" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-chevron-up"></i></span>
        </button>
       <button v-if="closetags" @click="closetags = false" type="button" title = "Показать тэги" class="close animated zoomIn flip" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-chevron-down"></i></span>
        </button>
      </card-header>
      <div v-if="!closetags" class="d-flex justify-content-between align-content-center flex-wrap mb-2 animated pulse">
        <button type="button" class="btn btn-nav blue darken-1 waves-effect" @click="searchFocus(' Brother ')">Brother</button>
        <button type="button" class="btn btn-nav btn-red waves-effect" @click="searchFocus(' Canon ')">Canon</button>
        <button type="button" class="btn btn-nav blue darken-2 waves-effect" @click="searchFocus(' Epson ')">Epson</button>
        <button type="button" class="btn btn-nav btn-indigo waves-effect" @click="searchFocus(' HP ')">HP</button>
        <button type="button" class="btn btn-nav blue darken-3 waves-effect" @click="searchFocus(' Konica ')">Konica</button>
        <button type="button" class="btn btn-nav btn-red waves-effect" @click="searchFocus(' Kyocera ')">Kyocera</button>
        <button type="button" class="btn btn-nav btn-green waves-effect" @click="searchFocus(' Lexmark ')">Lexmark</button>
        <button type="button" class="btn btn-nav btn-red waves-effect" @click="searchFocus(' Oki ')">Oki</button>
        <button type="button" class="btn btn-nav blue darken-4 waves-effect" @click="searchFocus(' Panasonic ')">Panasonic</button>
        <button type="button" class="btn btn-nav stylish-color-dark waves-effect" @click="searchFocus(' Pantum ')">Pantum</button>
        <button type="button" class="btn btn-nav btn-danger waves-effect" @click="searchFocus(' Ricoh ')">Ricoh</button>
        <button type="button" class="btn btn-nav blue darken-5 waves-effect" @click="searchFocus(' Samsung ')">Samsung</button>
        <button type="button" class="btn btn-nav danger-color-dark waves-effect" @click="searchFocus(' Sharp ')">Sharp</button>
        <button type="button" class="btn btn-nav btn-red waves-effect" @click="searchFocus(' Toshiba ')">Toshiba</button>
        <button type="button" class="btn btn-nav danger-color waves-effect" @click="searchFocus(' Xerox ')">Xerox</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' бушинг ')">Бушинг</button>
        <button type="button" class="btn btn-nav btn-elegant waves-effect" @click="searchFocus(' лезвие ')">Лезвие</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' картридж ')">Картридж</button>
        <button type="button" class="btn btn-nav btn-elegant waves-effect" @click="searchFocus(' Вал подачи ')">Магнитный</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' резиновый ')">Резиновый</button>
        <button type="button" class="btn btn-nav btn-elegant waves-effect" @click="searchFocus(' ракель ')">Ракель</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' ролик заряда ')">Ролик заряда</button>
        <button type="button" class="btn btn-nav btn-elegant waves-effect" @click="searchFocus(' ролик захвата ')">Ролик захвата</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' тормозная ')">Тормозная</button>
        <button type="button" class="btn btn-nav btn-elegant waves-effect" @click="searchFocus(' тонер ')">Тонер</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' термопленка ')">Термопленка</button>
        <button type="button" class="btn btn-nav btn-elegant waves-effect" @click="searchFocus(' тефлон ')">Тефлон</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' фотобарабан ')">Фотобарабан</button>
        <button type="button" class="btn btn-nav btn-elegant waves-effect" @click="searchFocus(' чернила ')">Чернила</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' чип ')">Чип</button>
      </div>
    </div>
      </template>
      <template v-if="filteredList.length > 400 &&  filteredList.length < goods.length">
       <div class="card col">
        <div class="card-body">
        <blockquote class="blockquote bq-primary">
          <p class="bq-title text-center">Уточните запрос, слишком много совпадений (<b>{{filteredList.length}}</b>)</p>
        </blockquote>
         </div>
         </div>
       </template>
        <template v-if="filteredList.length === 0 && goods.length > 0 && search!=''">
       <div class="card col">
        <div class="card-body">
         <blockquote class="blockquote bq-danger">
           <p class="bq-title text-center">Ничего не найдено - папка не содержит товаров или неверный запрос.</p>
           <footer class="blockquote-footer">Возможно это папка группы товаров. Выберите папку с товаром ниже или измените строку поиска.</footer>
           <footer class="blockquote-footer">Для поиска по всему каталогу выберите режим КАТАЛОГ слева вверху в дереве папок.</footer>
          </blockquote>
        </div>
      </div>
       </template>
      <template>
       <div v-if="filteredList.length === goods.length && folder0 === '00000000001' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote mobile-hide">
            <p class="bq-title text-start">Вы в режиме поиска товаров по всему каталогу. Введите ключевые слова в поле поиска</p>
            <footer class="blockquote-footer">например, "HP тонер 1010" или "тонер HP 1010" (русские и английские буквы отличаются, хоть и выглядят одинаково, бренды  - по-английски)</footer>
            <footer class="blockquote-footer">можно использовать значимые части слов - "фотоба" или "тон"</footer>
            <footer class="blockquote-footer">пробуйте искать как по модели принтера, так и по номеру картриджа: "HP 1005" или "HP 436"</footer>
            <p class="bq-title text-start">Также можно воспользоваться деревом папок</p>
            <footer class="blockquote-footer">Выберите папку с товарами внутри категорий товаров слева</footer>
            <footer class="blockquote-footer">В главном окне появится ее содержимое (Например, КАРТРИДЖИ->ЛАЗЕРНЫЕ СОВМЕСТИМЫЕ->HP)</footer>
            <footer class="blockquote-footer">При необходимости уточните модель в поле поиска</footer>
           </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '00000010161' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Тонер – это один из самых важных товаров в нашем каталоге.</p>
            <footer class="blockquote-footer">Мы имеем большой опыт и знания в этой области.</footer>
            <footer class="blockquote-footer">Мы предлагаем монохромный и цветной тонер от ведущих мировых брендов.</footer>
            <footer class="blockquote-footer">Мы можем подобрать для вас тонер, который будет соответствовать вашим потребностям и бюджету.</footer>
            <p class="bq-title text-start">Наша цель – обеспечить нашим клиентам высокое качество тонера</p>
            <footer class="blockquote-footer">Мы работаем под собственной торговой маркой White Toner.</footer>
            <footer class="blockquote-footer">Это дает нам возможность удовлетворить любые пожелания по объему и цене.</footer>
            <footer class="blockquote-footer">Использование нашего тонера позволяет сэкономить на расходах по печати, не ухудшая качество и не сокращая срок службы офисной техники.</footer>
           </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '00000010126' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Наша компания специализируется на поставках картриджей для различных видов принтеров.</p>
            <footer class="blockquote-footer">Мы учитываем пожелания и потребности наших клиентов и предлагаем им широкий выбор оригинальных и совместимых картриджей.</footer>
            <footer class="blockquote-footer">Мы работаем напрямую с ведущими производителями и гарантируем высокое качество и доступные цены на оригинальные картриджи. </footer>
            <footer class="blockquote-footer">Для тех, кто хочет снизить расходы без ущерба для качества печати, мы рекомендуем совместимые картриджи наших проверенных брендов TECH и White Cartridge.
</footer>
            </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '00000010179' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Фотобумага ТМ «White Paper» - это один из лучших вариантов для домашней фотопечати.</p>
            <footer class="blockquote-footer">Она изготавливается по немецкой технологии под контролем компании «Felix Sсhoeller», которая является лидером в области производства фотобумаги. </footer>
            <footer class="blockquote-footer">Фотобумага ТМ «White Paper» превосходит по качеству многие китайские бренды, так как имеет высокую плотность, стойкость к выцветанию и влаге, а также широкий цветовой диапазон.</footer>
           </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '00000010211' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Фотобарабаны</p>
            <footer class="blockquote-footer">Благодаря новейшему оборудованию и запатентованным технологиям производителя, качество фотобарабанов Tech отвечает высоким требованиям.</footer>
            <footer class="blockquote-footer">Обеспечивают высокое качество печати и производительную работу печатающего устройства.</footer>
            <footer class="blockquote-footer">Прекрасно совместимы с нашими тонерами и другими и расходными материалами.</footer>
            </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '00000010191' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Чипы</p>
            <footer class="blockquote-footer">максимальный ассортимент чипов для картриджей и аппаратов всех мировых производителей техники.</footer>
            <footer class="blockquote-footer">Работая напрямую с заводами-производителями, мы можем предложить вам любую новинку по чипам.</footer>
           </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '00000010172' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Чернила</p>
            <footer class="blockquote-footer">Чернила Ink-Mate™ – качественные чернила производимые компанией AlphaChem Co ltd.</footer>
            <footer class="blockquote-footer">Зарекомендовали себя как надежные чернила.</footer>
            <footer class="blockquote-footer">Изображение надолго сохранит яркость, благодаря внедрению новейших научных разработок применяемых для производства.</footer>
           </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '00000010200' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Если вы ищете качественные и надежные запчасти для принтеров и МФУ, то вы обратились по адресу.</p>
            <footer class="blockquote-footer">Наша компания предлагает широкий ассортимент запчастей для разных моделей техники, включая оригинальные и совместимые. </footer>
            <footer class="blockquote-footer">Для тех, кто хочет обеспечить стабильную работу техники и оптимизировать расходы на обслуживание, у нас есть бюджетный вариант запчастей из Китая.</footer>
            <footer class="blockquote-footer">Эти запчасти прошли строгий контроль качества и гарантируют долговечность и безотказность вашей техники.</footer>
           </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '00000010183' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Запчасти для картриджей</p>
            <footer class="blockquote-footer">Широкий выбор совместимых запчастей для ремонта техники и расходных материалов для перезаправки и восстановления картриджей.</footer>
            <footer class="blockquote-footer">Позволяет не только существенно экономить на печати, но и получать качество отпечатков сравнимое с оригиналом!</footer>
           </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === '99990001' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">CET</p>
            <footer class="blockquote-footer">Для ценителей качества продукта - мы предлагаем запчасти ТМ СЕТ - премиальный бренд и мировой лидер в разработке и производстве совместимых запасных частей и расходных материалов.</footer>
            </blockquote>
        </div>
      </div>
    </div>
    <div v-if="search === '' && filteredList.length === 0 && folder0 === 'D2616486' && folder1 === '00000000001' && folder2 === '00000000001'">
      <!-- Card -->
      <div class="card">
        <div class="card-body">
           <blockquote class="blockquote">
            <p class="bq-title text-start">Печатное оборудование</p>
            <footer class="blockquote-footer">Нашим партнерам и заказчикам мы всегда можем подобрать оборудование согласно их задачам и пожеланиям</footer>
            <footer class="blockquote-footer">Работаем с ведущими мировыми брендами печатающей техники такими, как RICOH, CANON, Hewlett-Packard, PANTUM, KYOCERA</footer>
           </blockquote>
        </div>
      </div>
    </div>
       </template>

       <div v-if="filteredList.length < 400 && !showAsList" class="row pl-3 pr-3">
        <div v-for="(good, index) in filteredList" :key="index" class="card col-md-6 mb-2 cascading-admin-card">
        <div v-if="!spinner" class="card-header d-flex">
            <b v-if="selectedContragent.UNP === '100511773'" class="mr-auto p-2">{{good.Articul}} </b>
            <b class="mr-auto p-2">{{good.NomCode}} </b>
            <!-- Card image -->
            <span  v-if="good.Akcionniy === 'Да'" type="btn btn-sm" class="input-group-text white-text hoverable red p-2 mr-0"
             title="АКЦИЯ!">SALE!</span>
             <span  v-if="good.hasPicture" type="btn btn-sm" class="input-group-text hoverable p-2" @click="showPicture(good.NomCode)"
             title="Показать фото"><img :src="'https://b2.belca.by/images/32/' + good.NomCode + '.png'" ></span>
            <span v-if = "good.fav === false" :key = "favkey" type="btn btn-sm" class="input-group-text hoverable p-2" @click="changeFav(good)"
             title="Добавить в избранное"><i  class="far fa-heart fa-lg" ></i> </span>
             <span v-if = "good.fav === true" :key = "favkey" type="btn btn-sm" class="input-group-text hoverable p-2" @click="changeFav(good)"
             title="Добавить в избранное"><i  class="fas fa-heart fa-lg" ></i> </span>
          </div>
        <!-- Card content -->
          <div class="card-body" v-bind:class="{'rgba-blue-slight' : good.Quantity>0 && isGoodAdded(good.NomCode)}">
              <!-- Text -->
                <div class="card-text">
                {{good.NomNaim}}
              </div>
            </div>
            <div class="card-footer d-flex flex-wrap justify-content-end">
              <div class="input-group-prepend col">
                    <span class=" input-group-text" style="cursor: pointer;" title='Цена с НДС'>{{getPrice(good.NomCode)}} {{selectedContragent.priceCurrency}}</span>
                    <template>
                        <span v-if="good.skladMain === undefined || good.skladMain <= 0" style="cursor: pointer;" class="input-group-text warning-color-dark text-white" title="На главном складе Тростенец товар отсутствует">{{0}}</span>
                        <span v-if="good.skladMain > 0 && (good.skladMainRezerv === 0 || good.skladMainRezerv === '')" style="cursor: pointer;" class="input-group-text info-color-dark text-white" title="На главном складе Тростенец.">{{good.skladMain}}</span>
                        <span v-if="good.skladMain > 0 && good.skladMainRezerv > 0 && (good.skladMainRezerv < good.skladMain)" style="cursor: pointer;" class="input-group-text info-color-dark text-white" :title="'На главном складе Тростенец. В резервах: ' + good.skladMainRezerv">{{good.skladMain}}</span>
                        <span v-if="good.skladMain > 0 && good.skladMainRezerv > 0 && (good.skladMainRezerv >= good.skladMain)" style="cursor: pointer;" class="input-group-text warning-color-dark text-white" :title="'На главном складе Тростенец весь товар в резерве. Уточняйте у менеджера!'">{{good.skladMain}}</span>
                    </template>
                    <template >
                        <span v-if="good.skladBelka === undefined || good.skladBelka <= 0 " style="cursor: pointer;" class="input-group-text warning-color-dark text-white" title="На складе Коласа товар отсутствует">{{0}}</span>
                        <span v-if="good.skladBelka > 0 && (good.skladBelkaRezerv === 0 || good.skladBelkaRezerv === '')" style="cursor: pointer;" class="input-group-text info-color-dark text-white" title='На складе Коласа.'>{{good.skladBelka}}</span>
                        <span v-if="good.skladBelka > 0 && good.skladBelkaRezerv > 0 && (good.skladBelkaRezerv < good.skladBelka)" style="cursor: pointer;" class="input-group-text info-color-dark text-white" :title="'На складе Коласа. В резервах: '+good.skladBelkaRezerv">{{good.skladBelka}}</span>
                        <span v-if="good.skladBelka > 0 && good.skladBelkaRezerv > 0 && (good.skladBelkaRezerv >= good.skladBelka)" style="cursor: pointer;" class="input-group-text warning-color text-white" :title="'На складе Коласа весь товар в резерве. Уточняйте у менеджера!'">{{good.skladBelka}}</span>
                    </template>
                    <template v-if="selectedContragent.Gorod === 'brest' && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                        <span v-if="good.skladBrest > 0 && (good.skladBrestRezerv === 0 || good.skladBrestRezerv === '')" style="cursor: pointer;" class="input-group-text info-color-dark text-white" title='На складе Брест.'>{{good.skladBrest}}</span>
                        <span v-if="good.skladBrest > 0 && good.skladBrestRezerv > 0" style="cursor: pointer;" class="input-group-text info-color-dark text-white" :title="'На складе Брест.В резервах: '+good.skladBrestRezerv">{{good.skladBrest}}</span>
                    </template>
                    <template v-if="selectedContragent.Gorod === 'gomel' && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                        <span v-if="good.skladGomel > 0 && (good.skladGomelRezerv === 0 || good.skladGomelRezerv === '')" style="cursor: pointer;" class="input-group-text info-color-dark text-white" title='На складе Гомель.'>{{good.skladGomel}}</span>
                        <span v-if="good.skladGomel > 0 && good.skladGomelRezerv > 0" style="cursor: pointer;" class="input-group-text info-color-dark text-white" :title="'На складе Гомель.В резервах: '+good.skladGomelRezerv">{{good.skladGomel}}</span>
                    </template>
                    <template v-if="selectedContragent.Gorod === 'grodno' && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                        <span v-if="good.skladGrodno > 0 && (good.skladGrodnoRezerv === 0 || good.skladGrodnoRezerv === '')" style="cursor: pointer;" class="input-group-text info-color-dark text-white" title='На складе Гродно.'>{{good.skladGrodno}}</span>
                        <span v-if="good.skladGrodno > 0 && good.skladGrodnoRezerv > 0" style="cursor: pointer;" class="input-group-text info-color-dark text-white" :title="'На складе Гродно.В резервах: '+good.skladGrodnoRezerv">{{good.skladGrodno}}</span>
                    </template>
                    <template v-if="selectedContragent.Gorod === 'mogilev' && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                      <span v-if="good.skladMogilev > 0 && (good.skladMogilevRezerv === 0 || good.skladMogilevRezerv === '')" style="cursor: pointer;" class="input-group-text info-color-dark text-white" title='На складе Могилев.'>{{good.skladMogilev}}</span>
                      <span v-if="good.skladMogilev > 0 && good.skladMogilevRezerv > 0" style="cursor: pointer;" class="input-group-text info-color-dark text-white" :title="'На складе Могилев.В резервах: '+good.skladMogilevRezerv">{{good.skladMogilev}}</span>
                    </template>
                    <template v-if="false">
                        <span style="cursor: pointer;" class="input-group-text secondary-color text-white" title='На складе Фасовка.В резервах: '>{{skladFasovka(good.NomCode)}}</span>
                    </template>
                    <template v-if=" (selectedContragent.Gorod === 'moskva' || selectedContragent.Gorod === 'rf') && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                        <span v-if="good.skladMoskva > 0 && (good.skladMoskvaRezerv === 0 || good.skladMoskvaRezerv === '')" style="cursor: pointer;" class="input-group-text info-color-dark text-white" title='На складе Москва.'>{{good.skladMoskva}}</span>
                        <span v-if="good.skladMoskva > 0 && good.skladMoskvaRezerv > 0" style="cursor: pointer;" class="input-group-text info-color-dark text-white" :title="'На складе Москва. В резервах: ' + good.skladMoskvaRezerv ">{{good.skladMoskva}}</span>
                    </template>
                  </div>
                  <div class="input-group-append d-flex flex-wrap justify-content-end">
                    <input class="form-control col-4" placeholder="0" type="number" :value="good.Quantity" @click="good.Quantity=calculateInput(good,$event)" @keyup="good.Quantity=calculateInput(good,$event)" aria-label="Количество для заказа, используйте стрелки вверх-вниз для изменения" title="Количество для заказа, используйте стрелки вверх-вниз для изменения">
                    <span v-if="good.Quantity!=''" @click = "good.Price = getPrice(good.NomCode); $emit('addGood', good)" type="btn btn-sm" class="input-group-text hoverable info-color"  title="Добавить в корзину"><i class="fas fa-cart-arrow-down"></i>
                </span>
              </div>
            </div>
           </div>
          </div>
        <!-- Вывод построчно -->
        <div v-if="filteredList.length < 400 && showAsList" class="row pl-3 pr-3">
        <div v-for="(good, index) in filteredList" :key="index" class="card col-md-12 cascading-admin-card">
         <!-- Card content -->
          <div class="card-body-sm row" v-bind:class="{'rgba-blue-slight' : good.Quantity>0 && isGoodAdded(good.NomCode)}">
                      <!-- Text -->
            <div class="col card-text">
            <span v-if = "good.fav === false" :key = "favkey" type="btn btn-sm" class="hoverable p-2" @click="changeFav(good)"
             title="Добавить в избранное"><i  class="far fa-heart fa-lg" ></i> </span>
             <span v-if = "good.fav === true" :key = "favkey" type="btn btn-sm" class="hoverable p-2" @click="changeFav(good)"
             title="Добавить в избранное"><i  class="fas fa-heart fa-lg" ></i> </span>
             <b class="mr-auto p-2">{{good.NomCode}}</b>
             <span  v-if="good.Akcionniy === 'Да'" type="btn btn-sm" class="white-text hoverable red"
             title="АКЦИЯ!">SALE!</span>
             {{good.NomNaim}}
             </div>
             <span  v-if="good.hasPicture" type="btn btn-sm" class="input-group-text hoverable p-2" @click="showPicture(good.NomCode)"
             title="Показать фото"><img :src="'https://b2.belca.by/images/32/' + good.NomCode + '.png '" ></span>
             <div class="col-4">
                  <div class="d-flex flex-wrap justify-content-end">
                    <span class="input-group-text" style="cursor: pointer;" title='Цена с НДС'>{{getPrice(good.NomCode)}} {{selectedContragent.priceCurrency}}</span>
                    <template>
                        <span v-if="good.skladMain === undefined || good.skladMain <= 0" style="cursor: pointer;" class="input-group-text warning-color-dark text-white" title="На главном складе Тростенец товар отсутствует">{{0}}</span>
                        <span v-if="good.skladMain > 0 && (good.skladMainRezerv === 0 || good.skladMainRezerv === '')" style="cursor: pointer;" class="input-group-text info-color-dark text-white" title="На главном складе Тростенец">{{good.skladMain}}</span>
                        <span v-if="good.skladMain > 0 && good.skladMainRezerv > 0 && (good.skladMainRezerv < good.skladMain)" style="cursor: pointer;" class="input-group-text info-color-dark text-white" :title="'На главном складе Тростенец. В резервах: ' + good.skladMainRezerv">{{good.skladMain}}</span>
                        <span v-if="good.skladMain > 0 && good.skladMainRezerv > 0 && (good.skladMainRezerv >= good.skladMain)" style="cursor: pointer;" class="input-group-text warning-color-dark text-white" :title="'На главном складе Тростенец весь товар в резерве. Уточняйте у менеджера!'">{{good.skladMain}}</span>
                    </template>
                    <template >
                        <span v-if="good.skladBelka === undefined || good.skladBelka <= 0 " style="cursor: pointer;" class="input-group-text warning-color-dark text-white" title="На складе Коласа товар отсутствует">{{0}}</span>
                        <span v-if="good.skladBelka > 0 && (good.skladBelkaRezerv === 0 || good.skladBelkaRezerv === '')" style="cursor: pointer;" class="input-group-text success-color-dark text-white" title='На складе Коласа.'>{{good.skladBelka}}</span>
                        <span v-if="good.skladBelka > 0 && good.skladBelkaRezerv > 0 && (good.skladBelkaRezerv < good.skladBelka)" style="cursor: pointer;" class="input-group-text success-color-dark text-white" :title="'На складе Коласа. В резервах: '+good.skladBelkaRezerv">{{good.skladBelka}}</span>
                        <span v-if="good.skladBelka > 0 && good.skladBelkaRezerv > 0 && (good.skladBelkaRezerv >= good.skladBelka)" style="cursor: pointer;" class="input-group-text warning-color text-white" :title="'На складе Коласа весь товар в резерве. Уточняйте у менеджера!'">{{good.skladBelka}}</span>
                    </template>
                    <template v-if="selectedContragent.Gorod === 'brest' && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                        <span v-if="good.skladBrest > 0 && (good.skladBrestRezerv === 0 || good.skladBrestRezerv === '')" style="cursor: pointer;" class="input-group-text success-color text-white" title='На складе Брест.'>{{good.skladBrest}}</span>
                        <span v-if="good.skladBrest > 0 && good.skladBrestRezerv > 0" style="cursor: pointer;" class="input-group-text success-color text-white" :title="'На складе Брест.В резервах: '+good.skladBrestRezerv">{{good.skladBrest}}</span>
                    </template>
                    <template v-if="selectedContragent.Gorod === 'gomel' && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                        <span v-if="good.skladGomel > 0 && (good.skladGomelRezerv === 0 || good.skladGomelRezerv === '')" style="cursor: pointer;" class="input-group-text success-color text-white" title='На складе Гомель.'>{{good.skladGomel}}</span>
                        <span v-if="good.skladGomel > 0 && good.skladGomelRezerv > 0" style="cursor: pointer;" class="input-group-text success-color text-white" :title="'На складе Гомель.В резервах: '+good.skladGomelRezerv">{{good.skladGomel}}</span>
                    </template>
                    <template v-if="selectedContragent.Gorod === 'grodno' && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                        <span v-if="good.skladGrodno > 0 && (good.skladGrodnoRezerv === 0 || good.skladGrodnoRezerv === '')" style="cursor: pointer;" class="input-group-text success-color text-white" title='На складе Гродно.'>{{good.skladGrodno}}</span>
                        <span v-if="good.skladGrodno > 0 && good.skladGrodnoRezerv > 0" style="cursor: pointer;" class="input-group-text success-color text-white" :title="'На складе Гродно.В резервах: '+good.skladGrodnoRezerv">{{good.skladGrodno}}</span>
                    </template>
                    <template v-if="selectedContragent.Gorod === 'mogilev' && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                      <span v-if="good.skladMogilev > 0 && (good.skladMogilevRezerv === 0 || good.skladMogilevRezerv === '')" style="cursor: pointer;" class="input-group-text success-color text-white" title='На складе Могилев.'>{{good.skladMogilev}}</span>
                      <span v-if="good.skladMogilev > 0 && good.skladMogilevRezerv > 0" style="cursor: pointer;" class="input-group-text success-color text-white" :title="'На складе Могилев.В резервах: '+good.skladMogilevRezerv">{{good.skladMogilev}}</span>
                    </template>
                    <template v-if="false">
                        <span style="cursor: pointer;" class="input-group-text secondary-color text-white" title='На складе Фасовка.В резервах: '>{{skladFasovka(good.NomCode)}}</span>
                    </template>
                    <template v-if=" (selectedContragent.Gorod === 'moskva' || selectedContragent.Gorod === 'rf') && selectedContragent.NePokazyvatSklandRegion !=='Да'">
                        <span v-if="good.skladMoskva > 0 && (good.skladMoskvaRezerv === 0 || good.skladMoskvaRezerv === '')" style="cursor: pointer;" class="input-group-text success-color text-white" title='На складе Москва.'>{{good.skladMoskva}}</span>
                        <span v-if="good.skladMoskva > 0 && good.skladMoskvaRezerv > 0" style="cursor: pointer;" class="input-group-text success-color text-white" :title="'На складе Москва. В резервах: ' + good.skladMoskvaRezerv ">{{good.skladMoskva}}</span>
                    </template>

                    <input class="form-control col-3" placeholder="0" type="number" :value="good.Quantity" @click="good.Quantity=calculateInput(good,$event)" @keyup="good.Quantity=calculateInput(good,$event)" aria-label="Количество для заказа, используйте стрелки вверх-вниз для изменения" title="Количество для заказа, используйте стрелки вверх-вниз для изменения">
                    <span v-if="good.Quantity!=''" @click = "good.Price = getPrice(good.NomCode); $emit('addGood', good)" type="btn btn-sm" class="input-group-text hoverable info-color"  title="Добавить в корзину"><i class="fas fa-cart-arrow-down"></i></span>
                  </div>
              </div>
            </div>
          </div>
          </div>

         <modal size="lg" v-if="showModal" @close="showModal = false">
           <modal-body class="d-flex justify-content-center">
         <!--   <vue-photo-zoom-pro v-if="showModal" :url="SelectedPicture" :high-url="SelectedPictureBig"> </vue-photo-zoom-pro> --->
            <template v-if="showModal">
              <mdb-view :src="SelectedPicture" class="zoom overlay" alt="Фото товара">
                <a>
                 <mdb-mask overlay="white-slight"></mdb-mask>
                </a>
              </mdb-view>
            </template>
           </modal-body>
          </modal>
         <back-to-top bottom="30px" right="30px">
          <button @click="$refs.inp.focus()" type="button" style="background-color: #607d8b;" class="btn  hoverable btn-to-top d-none d-lg-block"><i class="fa fa-chevron-up"></i></button>
        </back-to-top>
    </div>
</template>

<script>
import { mdbMask, Row, Column, Btn, Card, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, mdbBarChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Carousel, CarouselItem, CarouselCaption, mdbLineChart, mdbContainer, mdbView } from 'mdbvue'
import format from 'date-fns/format'
import subDays from 'date-fns/sub_days'
import ApiService from '@/services/ApiService'
import VuePhotoZoomPro from 'vue-photo-zoom-pro'
import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'
// import axios from 'axios'
import {
  Circle8
} from 'vue-loading-spinner'
export default {
  name: 'catalog',
  components: {
    mdbMask,
    mdbView,
    VuePhotoZoomPro,
    Row,
    Column,
    Circle8,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    mdbBarChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Carousel,
    CarouselItem,
    mdbLineChart,
    mdbContainer,
    CarouselCaption
  },
  props: ['authorized', 'ai', 'goods', 'prices', 'orders', 'loading', 'spinner', 'mng', 'rateUSD', 'mngsq', 'folder0', 'folder1', 'folder2', 'showPercent', 'showFavs', 'selectedContragent', 'selectedContragentBasket', 'stock'],
  data () {
    return {
      loadedpic: false,
      imgUrl: '',
      SelectedPictureSmall: '',
      SelectedPicture: '',
      SelectedPictureBig: '',
      sort: 0,
      isMobile: false,
      results: [],
      showAsList: false,
      mng10: false,
      search: '',
      debounce: null,
      inputDebounce: null,
      favkey: '',
      itemsSelected: 0,
      keys: ['NomCode', 'NomNaim'],
      loading2: false,
      showModal: false,
      hideSearchTip: false,
      closetags: false,
      inlist: false,
      profit: 20,
      goodABCXYZ: [],
      goodabc: '',
      goodstock: 0,
      reserved: 0,
      salesavg30: 0,
      salesavg60: 0,
      salesmax: 0,
      goodSelling: 0,
      goodshipment: 0,
      goodToOrder: 0,
      goodSales30: 0,
      forecast: [],
      goodSales: [],
      goodBuy: [],
      goodStock: [],
      orderComment: '',
      SkorionoTransit: [],
      barChartData: {
        labels: ['8', '7', '6', '5', '4', '3', '2', '1', format(Date(), 'WW')],
        datasets: [
          {
            label: 'Продажи',
            backgroundColor: 'rgba(245, 74, 85, 0.5)',
            data: this.goodSales
          },
          {
            label: 'Остатки',
            backgroundColor: 'rgba(245, 192, 50, 0.5)',
            data: this.goodStock
          },
          {
            label: 'Покупки',
            backgroundColor: 'rgba(0, 0, 255, 0.5)',
            data: this.goodBuy
          }
        ]
      },
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }]
        }
      }
    }
  },
  async mounted () {
    // this.UID = this.$localStorage.get('UID', 'false')
    // this.getGoods(this.UID)
    window.addEventListener('keydown', this.escCloseModal)
    console.log('Catalog mounted')
    this.$emit('chngai', 1)
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    // console.log(this.$route)
    // this.hideSearchTip = this.$localStorage.get('hideSearchTip', null, false)
    // this.hideOrderTip = this.$localStorage.get('hideOrderTip', null, false)
  },
  created () {
    this.$emit('chngai', 1)

    // console.log(this.$route)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkMobile)
  },
  beforeUpdate () {

  },
  updated () {
    this.$nextTick(() => {
      this.$emit('spinneroff')
    })
  },
  destroy () {
    window.removeEventListener('keydown', this.escCloseModal)
  },
  computed: {
    filteredList () {
      if (this.showFavs) {
        return this.goods.filter(good => good.fav === true)
      }
      var filteredArray = this.goods.filter(good => {
        /*
        if ((good.Parent_Key !== this.folder1 && good.Parent_Key !== this.folder2) && (this.folder1 !== '00000000-0000-0000-0000-000000000000' && this.folder2 !== '00000000-0000-0000-0000-000000000000')) return false
        if (this.folder1 === '00000000-0000-0000-0000-000000000000' && this.folder2 !== '00000000-0000-0000-0000-000000000000') return false
        */
        if (good.RoditelCode !== this.folder1 && good.RoditelCode !== this.folder2 && this.folder1 !== '00000000001' && this.folder2 !== '00000000001') {
          // console.log(' rule1')
          return false
        }
        if (good.RoditelCode !== this.folder1 && this.folder2 === '00000000001' && (this.folder1 !== '00000000001' && this.folder2 !== '00000000001')) {
          // console.log(' rule2')
          return false
        }
        if (this.folder1 === '00000000001' && this.folder2 !== '00000000001') {
          // console.log(' rule3')
          return false
        }
        if (good.RoditelCode !== this.folder1 && this.folder2 === '00000000001' && this.folder1 !== '00000000001') {
          // console.log(' rule4')
          return false
        }
        if (good.RoditelCode !== this.folder0 && this.folder0 !== '00000000001' && this.folder2 === '00000000001' && this.folder1 === '00000000001') {
          // console.log(' rule5')
          return false
        }
        var keywords = this.search.split(' ')
        var res = true

        keywords.forEach((element, index) => {
          var str = good.Articul + ' ' + good.NomNaim + ' ' + good.NomCode
          var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
          if (res === true && res1 === true) res = true
          if (res === false || res1 === false) res = false
        })

        // console.log(this.debouncedSearch)

        return res
      })
      if (filteredArray.length < 500) {
        filteredArray.forEach((good) => {
          var centemp = this.prices.filter(cena => cena.NomCode === good.NomCode)
          if (centemp.length === 1) { good.Cena = centemp[0].Cena } else { good.Cena = 0 }
        })
        filteredArray.sort((a, b) => {
          let fa = a.NomNaim.toLowerCase()
          let fb = b.NomNaim.toLowerCase()
          if (fa < fb) {
            return -1
          }
          if (fa > fb) {
            return 1
          }
          return 0
        })
      }
      if (this.sort === 0) { return filteredArray }
      if (this.sort === 1) { return filteredArray.sort((a, b) => a.Cena - b.Cena) }
      if (this.sort === 2) { return filteredArray.sort((a, b) => b.Cena - a.Cena) }
    },
    element (good) {
      return good.Ref_Key
    }
  },
  watch:
  {
    showFavs () {
      this.debounceClean()
    }
  },
  methods:
    {
      checkMobile () {
        this.isMobile = window.innerWidth <= 768 // Измените значение на свое усмотрение, чтобы определить пороговую ширину для мобильных устройств
      },
      changeView (mode) {
        this.showAsList = mode
        console.log(this.showAsList)
      },
      isGoodAdded (goodCode) {
        var res = this.selectedContragentBasket.filter(good => good.NomCode === goodCode)
        // console.log(res)
        if (res.length > 0) return true
        else return false
      //  console.log(res)
      },
      debounceSearch (event) {
        // this.search = ''
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          this.search = event.target.value
        }, 500)
      },
      debounceClean () {
        this.search = ''
        this.$refs.inp.value = ''
        // console.log(this.$refs.inp.value)
      },
      calculateInput (good, event) {
        console.log(event.target.value)

        if (event.target.value * 1 <= 0) {
          good.Quantity = ''
          return ''
        } else {
          // good.Quantity = event.target.value
          return event.target.value
        }
      },
      escCloseModal (e) {
        if (this.showModal && e.key === 'Escape') {
          this.showModal = false
        }
      },
      ChangeItem (good) {
        this.$emit('orderedItems')
      },
      async changeFav (good) {
        if (good.fav === true) good.fav = false
        else if (good.fav === false) good.fav = true
        this.favkey = Math.random()
        var selectedContragentFav = this.goods.filter(good => (good.fav === true))
        var favs = JSON.stringify(selectedContragentFav)
        // console.log('addFav ' + favs)
        var res = await ApiService.putFavFile(this.selectedContragent.UNP, favs)
        this.$emit('changeFav', this.favkey)
        console.log('res ' + res.status)
        // console.log(good.fav)
      },
      async showPicture (good) {
        // await new Promise(resolve => setTimeout(resolve, 1))

        this.SelectedPicture = 'https://b2.belca.by/images/720/' + good + '.jpg'
        // await new Promise(resolve => setTimeout(resolve, 1))
        this.SelectedPictureBig = 'https://b2.belca.by/images/720/' + good + '.jpg'

        // var res = await axios.get(this.SelectedPicture)
        // console.log(res)
        // await new Promise(resolve => setTimeout(resolve, 100))
        // console.log(this.SelectedPicture)
        // console.log(this.SelectedPictureBig)
        this.showModal = true
      },
      getPrice (goodCode) {
        var res = this.prices.filter(price => (price.NomCode === goodCode))
        // console.log(res.length)
        // if (res.length === 0) { res = this.prices.filter(price => (price.NomCode === goodCode && price.TipCenCode === '000000105')) }
        //  console.log(res[0].Cena)
        // if (res.length === 0) { res = this.prices.filter(price => (price.NomCode === goodCode && price.TipCenCode === '000000009')) }
        // console.log(res[0].Cena)
        if (res.length === 0) return 0
        // console.log(res[0].Cena)
        // return parseFloat(res[0].Cena.replaceAll(',', '.'))
        return res[0].Cena
      },
      skladBelka (goodCode) {
        if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000014'))
        // console.log(res)
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladBelkaRezerv (goodCode) {
        if (this.stock !== null) { var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000014')) }
        if (res.length === 0 || res[0].Rezerv === '') return 0
        // console.log(res[0].Rezerv)
        return res[0].Rezerv * 1
      },
      skladMain (goodCode) {
        if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000006'))
        //  console.log(res)
        // console.log(res)
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladMainRezerv (goodCode) {
        if (this.stock !== null) { var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000006')) }
        if (res.length === 0 || res[0].Rezerv === '') return 0
        else return res[0].Rezerv * 1
      },
      skladBrest (goodCode) {
        if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000055'))
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladBrestRezerv (goodCode) {
        if (this.stock !== null) { var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000055')) }
        if (res.length === 0 || res[0].Rezerv === '') return 0
        else return res[0].Rezerv * 1
      },
      skladVitebsk (goodCode) {
        if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000130'))
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladGomel (goodCode) {
        if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000031'))
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladGomelRezerv (goodCode) {
        if (this.stock !== null) { var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000031')) }
        if (res.length === 0 || res[0].Rezerv === '') return 0
        else return res[0].Rezerv * 1
      },
      skladGrodno (goodCode) {
        var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000052'))
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladGrodnoRezerv (goodCode) {
        if (this.stock !== null) { var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000052')) }
        if (res.length === 0 || res[0].Rezerv === '') return 0
        else return res[0].Rezerv * 1
      },
      skladMogilev (goodCode) {
        if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000065'))
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladMogilevRezerv (goodCode) {
        if (this.stock !== null) { var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000065')) }
        if (res.length === 0 || res[0].Rezerv === '') return 0
        else return res[0].Rezerv * 1
      },
      skladFasovka (goodCode) {
        if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000029'))
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladMoskva (goodCode) {
        if (this.stock !== null) var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000263'))
        if (res.length === 0) return 0
        return res[0].quantity * 1
      },
      skladMoskvaRezerv (goodCode) {
        if (this.stock !== null) { var res = this.stock.filter(stock => (stock.NomCode === goodCode && stock.Sklad === '000000263')) }
        if (res.length === 0 || res[0].Rezerv === '') return 0
        else return res[0].Rezerv * 1
      },
      changeSort () {
        if (this.sort === 0) this.sort = 1
        else if (this.sort === 1) this.sort = 2
        else if (this.sort === 2) this.sort = 0
        // console.log(this.sort)
      },
      async getGoodABCXYZ (uid) {
        // console.log('getGoodABCXYZ ' + uid)
        let answer = await ApiService.getGoodABCXYZ(uid)
        this.goodABCXYZ = answer.data.value
        // console.log(this.goodABCXYZ)
        this.goodabc = 'UU'
        var cl = this.goodABCXYZ
        var abc = ''
        var xyz = ''
        cl.forEach((el) => {
          if (el.ТипКлассификации === 'ABC') abc = el.Класс
          if (el.ТипКлассификации === 'XYZ') xyz = el.Класс
        })
        if (abc === 'AКласс') this.goodabc = 'A'
        if (abc === 'BКласс') this.goodabc = 'B'
        if (abc === 'CКласс') this.goodabc = 'C'
        if (abc === 'НеКлассифицирован') this.goodabc = 'U'
        if (xyz === 'XКласс') this.goodabc += 'X'
        if (xyz === 'YКласс') this.goodabc += 'Y'
        if (xyz === 'ZКласс') this.goodabc += 'Z'
        if (xyz === 'НеКлассифицирован') this.goodabc += 'U'
      },
      async getGoodReserves (uid) {
        // console.log('getGoodReserves')
        let answer = await ApiService.getGoodReserves(uid)
        var reserves = answer.data.value
        this.reserved = 0
        if (reserves.length > 0) this.reserved = reserves[0].КоличествоИзЗаказовBalance + reserves[0].КоличествоНеобеспеченоBalance + reserves[0].КоличествоПодЗаказBalance
        else this.reserved = 0
      },
      async getGoodToShipment (uid) {
        console.log('getGoodToShipment')
        let answer = await ApiService.getGoodToShipment(uid)
        var shipment = answer.data.value
        this.goodshipment = 0
        shipment.forEach((transit) => {
          this.goodshipment += transit.КоличествоИзЗаказовBalance
        })
      },
      async getGoodSelling (uid) {
        console.log('getGoodSelling')
        let answer = await ApiService.getGoodSelling(uid)
        var selling = answer.data.value
        // console.log(selling)
        this.goodSelling = 0
        selling.forEach((order) => {
          this.goodSelling += order.КОформлениюBalance
        })
      },
      async getGoodSales (uid) {
        // var res = this.goods.filter(good => good.Ref_Key === uid)
        // console.log('АналитикаНоменклатуры_Key ' + res[0].АналитикаНоменклатуры_Key)
        this.getGoodToShipment(uid)
        this.getGoodABCXYZ(uid)
        this.getGoodReserves(uid)
        this.getGoodSelling(uid)
        this.salesavg60 = 0
        this.goodSales30 = 0
        this.goodstock = 0
        this.salesavg30 = 0
        this.salesmax = 0
        this.goodSales = []
        console.log('getGoodSales ' + uid)
        for (var i = 0; i < 8; i++) {
          var startDate = format(subDays(Date(), i * 7 + 7), 'YYYY-MM-DD')
          var endDate = format(subDays(Date(), i * 7 - 1), 'YYYY-MM-DD')
          const response = await ApiService.goodSalesByPeriod(uid, startDate, endDate)
          let data = response.data.value
          if (data.length > 0) {
            this.goodSales[7 - i] = data[0].ВНаличииExpense
            this.salesavg60 += data[0].ВНаличииExpense
            if (data[0].ВНаличииExpense > this.salesmax) this.salesmax = data[0].ВНаличииExpense
            this.goodBuy[7 - i] = data[0].ВНаличииReceipt
            this.goodStock[7 - i] = data[0].ВНаличииClosingBalance
            if (i < 4) this.goodSales30 += data[0].ВНаличииExpense
            console.log(startDate, ' ', endDate, ' ', data[0].ВНаличииExpense)
          } else {
            this.goodSales[7 - i] = 0
            this.goodBuy[7 - i] = 0
            this.goodStock[7 - i] = 0
          }
        }
        this.goodstock = Math.round(this.goodStock[7])
        this.salesavg60 = Math.round(this.salesavg60 / 8)
        this.salesavg30 = Math.round(this.goodSales30 / 4)
        console.log('Класс: ' + this.goodabc)
        console.log('На складе: ' + this.goodstock)
        console.log('Отгружается  ' + this.goodSelling)
        console.log('В резервах: ' + this.reserved)
        console.log('Транзит: ' + this.goodshipment)
        console.log('Пиковые продажи в неделю за 2 месяца:' + this.salesmax)
        console.log('Средние продажи в неделю за 2 месяца:' + this.salesavg60)
        console.log('Средние продажи в неделю за месяц: ' + this.salesavg30)
        this.goodToOrder = this.salesavg30 - this.goodstock + this.reserved + this.goodSelling - this.goodshipment
        console.log('Заказать: ' + this.goodToOrder)
        // var coeff = this.salesavg30 / this.salesavg60
        this.orderComment = ''
        // console.log('Коэффициент: ' + coeff)
        // if (coeff !== 0) this.goodToOrder = Math.round(this.goodToOrder * coeff)
        if (this.salesavg60 < this.salesavg30) {
          this.orderComment += 'Продажи растут.'
        }
        if (this.salesavg60 > this.salesavg30) {
          this.orderComment += 'Продажи падают.'
        }
        if (this.goodToOrder === 0) {
          this.orderComment += ' Нет необходимости в заказе товара на неделю.'
        }
        if (this.goodToOrder > 0 && this.goodshipment === 0) {
          this.orderComment += ' Необходимо заказать ' + this.goodToOrder + 'шт на неделю.'
        }
        if (this.goodToOrder > 0 && this.goodshipment > 0) {
          this.orderComment += ' Товар едет, но его количество не покроет потребностей. Необходимо дозаказать еще ' + this.goodToOrder + 'шт на неделю.'
        }
        if (this.goodToOrder < 0 && this.goodstock >= this.salesavg30) {
          if (Math.abs(Math.round(this.goodstock / this.salesavg30)) === 0) {
            this.orderComment += ' ЗАПАСЫ ОПТИМАЛЬНЫ, планируемый срок продажи остатков в неделях: ' + Math.abs(Math.round(this.goodstock / this.salesavg30))
          } else {
            this.orderComment += ' Запасов достаточно, планируемый срок продажи остатков в неделях: ' + Math.abs(Math.round(this.goodstock / this.salesavg30))
          }
        }
        if (this.goodToOrder < 0 && this.goodstock < this.salesavg30 && this.goodshipment > this.salesavg30) {
          this.orderComment += ' Запасов на складе недостаточно, товар заказан и находится в транзите. С учетом транзита планируемый срок продажи товара после прихода на склад в неделях: ' + Math.abs(Math.round((this.goodToOrder + this.goodstock) / this.salesavg30))
        }

        this.barChartData = {
          labels: [format(subDays(Date(), 7 * 7), 'WW'), format(subDays(Date(), 6 * 7), 'WW'), format(subDays(Date(), 5 * 7), 'WW'), format(subDays(Date(), 4 * 7), 'WW'), format(subDays(Date(), 3 * 7), 'WW'), format(subDays(Date(), 2 * 7), 'WW'), format(subDays(Date(), 7), 'WW'), format(Date(), 'WW')],
          datasets: [
            {
              label: 'Продажи',
              backgroundColor: 'rgba(255, 0, 0, 0.3)',
              data: this.goodSales
            },
            {
              label: 'Остатки',
              backgroundColor: 'rgba(245, 192, 50, 0.3)',
              data: this.goodStock
            },
            {
              label: 'Покупки',
              backgroundColor: 'rgba(0, 255, 0, 0.3)',
              data: this.goodBuy
            }
          ]
        }
        // this.showModal = true
      },
      setProfit (good) {
        // console.log(good)
        if (this.profit === 40) {
          good.Price = Math.round((good.Себестоимость * 1.4) * 100) / 100
          this.profit = 5
        } else if (this.profit === 5) {
          good.Price = Math.round((good.Себестоимость * 1.05) * 100) / 100
          this.profit = 15
        } else if (this.profit === 15) {
          good.Price = Math.round((good.Себестоимость * 1.15) * 100) / 100
          this.profit = 20
        } else if (this.profit === 20) {
          good.Price = Math.round((good.Себестоимость * 1.2) * 100) / 100
          this.profit = 35
        } else if (this.profit === 35) {
          good.Price = Math.round((good.Себестоимость * 1.35) * 100) / 100
          this.profit = 40
        }
      },
      calculateid (refkey) {
        return 'i' + refkey
      },
      transit (good) {
        return 'Транзит к ' + this.$moment(good.DeliveryDate).format('DD-MM-YYYY')
      },
      searchFocus (str) {
        this.showOnce = false
        this.$refs.inp.focus()
        // console.log(str)
        this.search += str
        this.$refs.inp.value = this.search
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.blockquote .bq-title {
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
}

input::placeholder {
    font-weight: bold;
    opacity: 1;
    color: lightgray;
}
.card-img-top {
    width: 100%;
    height: 10vw;
    object-fit: scale-down;
  }
  .btn-to-top {
    border-radius: 50%;
    padding: 1rem;
    padding-top: 0.9rem;
    padding-right: 1.1rem;
    padding-bottom: 0.9rem;
    padding-left: 1.1rem;
  }
.btn.btn-nav {
    padding: 0.1rem 1.0rem;
    font-size: 0.64rem;
  }
.badge-pill {
    border-radius: 10rem;
    padding-right: 0.6em;
    margin-top: 0.6em;
  }
.form-control:focus {
    border:0px
    }
.form-control {
    height:auto;
    border: 1px solid;
    }
.order-btn {
    margin-top: 0.375rem;
    margin-left: 0rem;
    }
.search {
    border: 1px solid #61c8ea;
 }
.stock {
    border: 1px solid #0099cc;
    }
.miss {
    border: 1px solid #424242;
    }
 .skorpiono {
    border: 1px solid #9933cc;
    }
.transit {
    border: 1px solid #ff8800;
    }
.w-120 {
    width: 120px!important;
}
.w-50 {
    width: 60px!important;
}
.inp {
    font-size: 1.5rem;
}
.md-form {
    position: relative;
    margin-top: 0rem;
    margin-bottom: 0rem;
}
.md-form.input-group .form-control {
    margin: 0;
    padding: 0.375rem 0.75rem;
    background-color: white;
}
.cascading-admin-card {
  padding-left: 10px;
  padding-right: 10px;
}
.m-0 {
    margin: 0.4rem!important;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fa {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 20px 0 rgba(0, 0, 0, 0.19);
}
.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.admin-up .data p {
  color: #999999;
  font-size: 12px;
}
.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}

.card-header {
    padding: 0.35rem 0.35rem;
}
.card-footer {
    padding: 0.35rem 0.35rem;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
.card {
     border: 1px solid rgba(0, 0, 0, 0.125);
 }
 .row {

    margin-right: 0px;
    margin-left: 0px;
 }
 .card-body {
    -ms-flex: 1 1 auto;
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    min-height: 1px;
    padding: 0.25rem;
}
 .card-body-sm {
    padding: 0.25rem;
}
.card-text {
    color: #747373;
    font-size: 0.9rem;
    font-weight: 400;
}
@media only screen and (max-width: 900px) {
    .mobile-hide {
      display: none !important;
    }

   body {

    line-height: 1;

}
    .modal-content {
      width: 60% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Catalog.vue